import types from './types';
import {
    fetchElementsPaginated,
    fetchElement,
    submitElement,
    deleteElement
} from './common';
import {CALL_API} from 'redux-api-middleware';

const apiUrl = '/api/partner-categories';

export function submitPartnerCategory(values) {
    return submitElement(apiUrl, values, types.SUBMIT_PARTNER);
}

export function fetchPartnerCategory(itemId) {
    return fetchElement(apiUrl, itemId, types.ADMIN_LOAD_PARTNER_CATEGORY);
}

export function fetchPartnerCategories(page = 0, size = 10) {
    return fetchElementsPaginated(`${apiUrl}/paginated`, page, size, types.ADMIN_LOAD_PARTNER_CATEGORIES);
}

export function deletePartnerCategory(partner) {
    return deleteElement(apiUrl, partner.id, types.DELETE_PARTNER_CATEGORY);
}


export function fetchAllPartnerCategories() {
    return {
        [CALL_API]: {
            endpoint: apiUrl,
            method: 'GET',
            types: types.LOAD_PARTNER_CATEGORIES.all
        }
    };
}



// WEBPACK FOOTER //
// ./src/js/actions/partner-categories.js